import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators} from 'redux'
import PropTypes from 'prop-types'
import {Tab, Card, Button, Form} from 'semantic-ui-react'
import {
    noteCruded
} from '../../../actions/relation'
import {api} from "../../../api";

class NoteTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            note: "",
            actionId: null,
            loading: false
        }
    }

    onNoteSubmit = () => {
        this.setState({loading: true})
        if (this.state.actionId) {
            api.relation.notes.update(this.props.jwt, this.props.relationId, this.state.actionId, this.state.note).then(res => {
                this.props.noteCruded(this.state.actionId, res.data.data, 'update');
                this.setState({
                    note: "",
                    actionId: null,
                    loading: false
                })
            })
        } else {
            api.relation.notes.add(this.props.jwt, this.props.relationId, this.state.note).then(res => {
                this.props.noteCruded(this.state.actionId, res.data.data, 'create');
                this.setState({
                    note: "",
                    actionId: null,
                    loading: false
                })
            })
        }
    }

    onNoteEditClick = (note) => {
        if (note.id === this.state.actionId) {
            this.setState({
                note: "",
                actionId: null
            })
        } else {
            this.setState({
                note: note.note,
                actionId: note.id
            })
        }
    }

    onDeleteNoteClick = (note) => {
        api.relation.notes.delete(this.props.jwt, this.props.relationId, note.id).then(res => {
            this.props.noteCruded(note.id, note, 'delete')
        })
    }

    render() {
        const {notes} = this.props;
        return (
            <Tab.Pane>
                <div className="row">
                    <div className="col-md-12">
                        <Card.Group>
                        {notes.map(n => {
                            return <Card key={n.id}>
                                <Card.Content>
                                    <Card.Meta>
                                        <div style={{float: 'left'}}>
                                            <a onClick={() => {
                                                this.onNoteEditClick(n)
                                            }}>Edit</a>
                                        </div>
                                        <div style={{float: 'right'}}>
                                            <a onClick={() => {
                                                this.onDeleteNoteClick(n)
                                            }}>
                                                Delete
                                            </a>
                                        </div>
                                    </Card.Meta>
                                    <Card.Description>
                                        {n.id === this.state.actionId ? <Form>
                                            <Form.TextArea name="description"
                                                           value={this.state.note}
                                                           onChange={(e) => { this.setState({
                                                               note: e.target.value
                                                           }) }}
                                            />
                                            <Button size='mini' color='teal'
                                                    onClick={this.onNoteSubmit}
                                                    loading={this.state.loading}>Update</Button>
                                        </Form> : <p style={{'whiteSpace': 'pre-line'}}>{n.note}</p>}
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        })}
                        </Card.Group>
                    </div>
                </div>
                {_.isNull(this.state.actionId) ? <div className="row">
                    <div className="col-md-12" style={{marginTop: '20px'}}>
                        <Card>
                            <Card.Content>
                                <Card.Description>
                                    <Form>
                                        <Form.TextArea name="description"
                                                       value={this.state.note}
                                                       onChange={(e) => { this.setState({
                                                           note: e.target.value
                                                       }) }}
                                        />
                                        <Button size='mini' color='teal'
                                                onClick={this.onNoteSubmit}
                                                loading={this.state.loading}>Create</Button>
                                    </Form>
                                </Card.Description>
                            </Card.Content>
                        </Card>
                    </div>
                </div> : null}
            </Tab.Pane>
        )
    }
}

NoteTab.propTypes = {
    notes: PropTypes.array.isRequired,
    relationId: PropTypes.number.isRequired,
    jwt: PropTypes.string.isRequired,
    noteCruded: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        noteCruded
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteTab)



// WEBPACK FOOTER //
// ./src/components/relations/parts/NoteTab.js